import React, { Component } from "react";
import { Avatar } from "material-ui";

export default class PractitionerAvatar extends Component {
  static defaultProps = {
    src: ""
  };

  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  handleError = () => {
    this.setState({ error: true });
  };

  render() {
    return !this.state.error && !this.props.useInitial ? (
      <img
        src={this.props.src}
        style={{ width: 60, height: 60 }}
        alt={this.props.initial}
        onError={this.handleError}
      />
    ) : (
      <Avatar size={60}>{this.props.initial}</Avatar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/PractitionerAvatar.js